import PublicContentBase from '../../ContentBase'
import './Styles.scss'

const PublicContentLaserDigital = (): JSX.Element => {
    return <PublicContentBase />
}

export default PublicContentLaserDigital
